export default __webpack_public_path__ + "static/media/skyandsonslogo-bg-transparent.2e5af992.png";